import { render } from "./header.html?vue&type=template&id=a5de6d96&scoped=true&external"
import script from "./header.ts?vue&type=script&lang=js&external"
export * from "./header.ts?vue&type=script&lang=js&external"

import "./header.scss?vue&type=style&index=0&id=a5de6d96&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5de6d96"],['__file',"src/components/layout/header/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "a5de6d96"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('a5de6d96', __exports__)) {
    api.reload('a5de6d96', __exports__)
  }
  
  module.hot.accept("./header.html?vue&type=template&id=a5de6d96&scoped=true&external", () => {
    api.rerender('a5de6d96', render)
  })

}


export default __exports__